<h2 class="title">Logowanie</h2>
<div class="login-page-holder">
  <!-- Header Section -->
  <div class="login-header">

    <p>Wprowadź swoje dane, aby uzyskać dostęp do panelu użytkownika.</p>
  </div>

  <!-- Two Column Layout -->
  <div class="login-grid">

    <!-- Column 1: Login Form -->
    <div class="login-column login-form-column">
      <div class="column-header">
        <mat-icon class="header-icon">login</mat-icon>
        <h2>Logowanie</h2>
      </div>
      <div class="column-content">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <!-- Email Field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" />
            @if (loginForm.get('email')?.hasError('required')) {
              <mat-error>
                Email jest wymagany
              </mat-error>
            }
            @if (loginForm.get('email')?.hasError('email')) {
              <mat-error>
                Email jest nieprawidłowy
              </mat-error>
            }
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Hasło</mat-label>
            <input matInput type="password" formControlName="password" />
            @if (loginForm.get('password')?.hasError('required')) {
              <mat-error>
                Hasło jest wymagane
              </mat-error>
            }
            @if (loginForm.get('password')?.hasError('minlength')) {
              <mat-error>
                Hasło musi mieć co najmniej 8 znaków
              </mat-error>
            }
          </mat-form-field>

          <!-- Password reminder link -->
          <div class="password-reminder-link">
            <a routerLink="/przypomnienie-hasla">Nie pamiętasz hasła?</a>
          </div>

          <!-- Submit Button -->
          <div class="actions-holder">
            <button mat-raised-button class="custom-button" type="submit" [disabled]="loginForm.invalid">
              Zaloguj się
            </button>
          </div>

          <!-- Register link -->
          <div class="register-link">
            <a routerLink="/rejestracja">Nie masz konta? Zarejestruj się</a>
          </div>
        </form>
      </div>
    </div>

    <!-- Column 2: Security Guidelines -->
    <div class="login-column security-column">
      <div class="column-header">
        <mat-icon class="header-icon">security</mat-icon>
        <h2>Bezpieczeństwo</h2>
      </div>
      <div class="column-content">
        <div class="security-info">
          <p class="security-intro">
            <strong>Dbaj o bezpieczeństwo swojego konta:</strong>
          </p>

          <div class="security-tips">
            <div class="security-tip">
              <mat-icon class="tip-icon">lock</mat-icon>
              <div class="tip-content">
                <h4>Silne hasło</h4>
                <p>Używaj hasła o długości minimum 8 znaków zawierającego litery, cyfry i znaki specjalne</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">visibility_off</mat-icon>
              <div class="tip-content">
                <h4>Nie udostępniaj hasła</h4>
                <p>Nigdy nie podawaj swojego hasła innym osobom ani nie zapisuj go w miejscach dostępnych dla innych</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">devices</mat-icon>
              <div class="tip-content">
                <h4>Bezpieczne urządzenia</h4>
                <p>Loguj się tylko na zaufanych urządzeniach i zawsze wyloguj się po zakończeniu pracy</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">update</mat-icon>
              <div class="tip-content">
                <h4>Regularne zmiany</h4>
                <p>Zmieniaj hasło regularnie, szczególnie gdy podejrzewasz, że mogło zostać skompromitowane</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">wifi_protected_setup</mat-icon>
              <div class="tip-content">
                <h4>Bezpieczne połączenie</h4>
                <p>Unikaj logowania się przez publiczne sieci Wi-Fi. Używaj zabezpieczonych połączeń</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">email</mat-icon>
              <div class="tip-content">
                <h4>Uwaga na phishing</h4>
                <p>Nie klikaj w podejrzane linki w emailach. Zawsze sprawdzaj adres strony przed logowaniem</p>
              </div>
            </div>
          </div>

          <div class="help-section">
            <h4>Potrzebujesz pomocy?</h4>
            <p>W przypadku problemów z logowaniem skontaktuj się z nami:</p>
            <div class="contact-info">
              <p><mat-icon>email</mat-icon> <a href="mailto:biuro@zgranegrono.pl">biuro@zgranegrono.pl</a></p>
              <p><mat-icon>phone</mat-icon> <a href="tel:683200630">68 320 06 30</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>